<div class="p-3 align-items-center" style="margin: 0 auto; text-align: center; height: auto;">
	<!-- Growing spinner -->
	<div class="spinner-border text-primary" role="status">
	  <span class="sr-only">Loading...</span>
	</div>
  </div>
